import { render, staticRenderFns } from "./ModalItemContactEdit.vue?vue&type=template&id=46086293&scoped=true"
import script from "./ModalItemContactEdit.vue?vue&type=script&lang=ts"
export * from "./ModalItemContactEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46086293",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46086293')) {
      api.createRecord('46086293', component.options)
    } else {
      api.reload('46086293', component.options)
    }
    module.hot.accept("./ModalItemContactEdit.vue?vue&type=template&id=46086293&scoped=true", function () {
      api.rerender('46086293', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalItemContactEdit.vue"
export default component.exports